export const paymentMethodMap: { [key: string]: string } = {
    applepay: "Apple Pay",
    googlepay: "Google Pay",
    mc: "Mastercard",
    visa: "Visa",
    amex: "American Express",
    rupay: "RuPay",
    diners: "Diners",
    discover: "Discover",
    maestro: "Maestro",
    cup: "UnionPay",
    jcb: "JCB",
    paypal: "PayPal",
    upi: "UPI",
    kcp_payco: "PayCo",
    kcp_naverpay: "NaverPay",
    kakaopay: "KakaoPay",
    kcp_banktransfer: "Bank Transfer",
    kcp_creditcard: "Credit Card",
    klarna_account: "Klarna",
    klarna_paynow: "Klarna",
    klarna: "Klarna",
    grabpay: "GrabPay",
    zip: "Zip",
    afterpaytouch: "Afterpay Touch",
    paypay: "PayPay",
    econtext_stores: "Konbini Payment",
    amazon_pay: "Amazon Pay",
    blik: "BLIK",
    onlinebanking_pl: "Przelewy24",
    ideal: "iDEAL",
};

export const cardPaymentKeys = new Set([
    "mc",
    "visa",
    "amex",
    "diners",
    "discover",
    "rupay",
    "maestro",
    "cup",
    "jcb",
]);
